export function VideoPlayer({ src, title }: { src: string; title: string }): React.JSX.Element {
  return <section className="video-player"><h3>{title}</h3><video controls preload="metadata" src={src}>Your browser does not support MP4 playback.</video><a className="button-secondary" href={src} download>Download video</a></section>;
}
